import { RouteGroupItemSideloading } from '@ekt-group/general-purpose-api-interfaces/src/types/route-group-items.enum';
import { MapComponent, MapMode, MapTileMode } from '@ekt-group/map-component';
import React, { Suspense, useEffect, useRef, useState } from 'react';

import { getTodayDate, getTomorrowDate } from '@/helpers/date-helper';
import { useLocale } from '@/hooks/use-locale';
import { getRandomColor } from '@/utils/random-color';

import { useGetRouteGroupItems } from '../api/use-get-route-group-items';

const RouteGroupItemsMap = () => {
  const { currentLocale } = useLocale();

  const [selectedWaypointIds, setSelectedWaypointIds] = useState<number[]>([]);

  const routeGroupItemsQuery = useGetRouteGroupItems({
    sideloading: [
      RouteGroupItemSideloading.RouteGroup,
      RouteGroupItemSideloading.Car,
      RouteGroupItemSideloading.Driver,
      RouteGroupItemSideloading.Loader,
      RouteGroupItemSideloading.Base,
    ],
    startDate: getTodayDate(),
    endDate: getTomorrowDate(),
    disablePagination: true,
    driverIds: [985],
  });

  const colorsRef = useRef<Record<string, string>>({});

  useEffect(() => {
    const ids = routeGroupItemsQuery.data?.map((item) => item.id) || [];

    const initialColors = ids?.reduce((acc: Record<(typeof ids)[number], string>, routeGroupItemId) => {
      if (!colorsRef.current[routeGroupItemId]) {
        acc[routeGroupItemId] = getRandomColor();
      }
      return acc;
    }, {});

    colorsRef.current = { ...colorsRef.current, ...initialColors };
  }, [routeGroupItemsQuery.data]);

  const handleObjectClick = (waypointIds: number[]) => {
    setSelectedWaypointIds(waypointIds);
  };

  return (
    <div className="relative w-full h-full">
      {routeGroupItemsQuery.isLoading ? (
        <div className="bg-gray-300 w-full h-full animate-pulse"></div>
      ) : (
        <Suspense>
          <MapComponent
            mode={MapMode.RouteGroupItems}
            routeGroupItems={routeGroupItemsQuery.data}
            locale={currentLocale}
            tilesMode={MapTileMode.Eomap}
            selectedWaypointIds={selectedWaypointIds}
            onObjectClick={handleObjectClick}
            settings={{
              stickToCar: true,
              autoZoom: true,
              showDoneWaypoints: true,
              enableRotation: true,
              isGeolocationEnabled: true,
            }}
            generalPurposesHostUrl={import.meta.env.VITE_GENERAL_PURPOSE_HOST_URL}
          />
        </Suspense>
      )}
    </div>
  );
};

export default RouteGroupItemsMap;
